/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Step_4Inputs */

const en_svc_n8n_step_4 = /** @type {(inputs: Svc_N8n_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hand over with documentation, credentials in your name and an agreed owner.`)
};

const lv_svc_n8n_step_4 = /** @type {(inputs: Svc_N8n_Step_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nododam ar dokumentāciju, piekļuvēm uz Jūsu vārda un saskaņotu atbildīgo.`)
};

/**
* | output |
* | --- |
* | "Hand over with documentation, credentials in your name and an agreed owner." |
*
* @param {Svc_N8n_Step_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_step_4 = /** @type {((inputs?: Svc_N8n_Step_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Step_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_step_4(inputs)
	return en_svc_n8n_step_4(inputs)
});